import React from 'react';
import c from 'classnames';
import s from './Title.scss';

export interface Props {
  value: string;
  className?: string;
  isConcise?: boolean;
}

const Title: React.FC<Props> = ({ value, isConcise, className }) => {
  return (
    <div className={c(s['title'], isConcise && s['concise'], className)}>
      {value}
    </div>
  );
};
Title.displayName = 'Title';

export default Title;
